import type { FC } from 'react';
import React from 'react';

import type { IPentagramGrid } from './models';

export const PentagramGrid: FC<IPentagramGrid> = ({ strokeWidth }) => (
    <svg
        fill="none"
        height="143"
        viewBox="0 0 150 143"
        width="150"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g stroke="#E7E8EC" strokeWidth={strokeWidth}>
            <path d="M79.104 3.20461L145.69 51.3948C148.153 53.1773 149.184 56.3458 148.241 59.2362L122.82 137.171C121.881 140.051 119.195 142 116.165 142H33.8348C30.8051 142 28.1194 140.051 27.1799 137.171L1.75881 59.2362C0.815996 56.3458 1.84674 53.1773 4.30969 51.3948L70.896 3.20461C73.345 1.43222 76.6551 1.43221 79.104 3.20461Z" />
            <path d="M79.1534 21.3039L126.783 56.4126C129.201 58.195 130.212 61.3214 129.296 64.1822L111.056 121.135C110.128 124.033 107.433 126 104.39 126H45.6103C42.5668 126 39.872 124.033 38.9438 121.135L20.7044 64.1822C19.7883 61.3214 20.7995 58.195 23.2175 56.4126L70.8466 21.3039C73.3163 19.4834 76.6837 19.4834 79.1534 21.3039Z" />
            <path d="M79.1412 42.279L107.76 63.2787C110.189 65.0611 111.205 68.1979 110.282 71.0661L99.3189 105.144C98.3878 108.038 95.6953 110 92.6552 110H57.3448C54.3047 110 51.6122 108.038 50.6812 105.144L39.7178 71.0661C38.7951 68.1979 39.8111 65.0611 42.2403 63.2787L70.8588 42.279C73.3234 40.4706 76.6766 40.4706 79.1412 42.279Z" />
            <path d="M79.1737 62.3455L87.8201 68.7673C90.2197 70.5495 91.2229 73.6587 90.3175 76.5073L86.9441 87.1204C86.0205 90.0263 83.3221 92 80.273 92H69.727C66.6779 92 63.9795 90.0263 63.0559 87.1204L59.6825 76.5072C58.7771 73.6587 59.7803 70.5495 62.1799 68.7673L70.8263 62.3455C73.3044 60.505 76.6956 60.505 79.1737 62.3455Z" />
            <path d="M2 55.4342L75 78.5652M75 78.5652V2M75 78.5652L148 55.4342M75 78.5652L29.6216 140.608M75 78.5652L120.378 141" />
        </g>
    </svg>
);
